// extracted by mini-css-extract-plugin
export default {"services":"Services_services__qhTp3","title":"Services_title__45fW8","services-container":"Services_services-container__lvxUy","service":"Services_service__ms-SP"};